export default "__VITE_ASSET__BOnMUOU1__"